import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { validationOfPriceListRules } from 'modules/accommodations/features/reservations/api';

export const useValidationOfPriceListRules = () => {
  const queryClient = useQueryClient();
  const { errorToast } = useCustomToast();

  const {
    mutateAsync: checkPriceListRulesMutation,
    isLoading: priceListRulesLoading,
    isError: priceListRulesError,
    data,
  } = useMutation(validationOfPriceListRules, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RESERVATIONS_PRICE_LIST_RULES_VALIDATION);
    },
    onError: () => errorToast(),
  });

  return {
    checkPriceListRulesMutation,
    priceListRulesLoading,
    priceListRulesError,
    priceListRulesData: data?.data,
  };
};
